import React, { useContext, useState } from "react";
import moment from "moment";

import { LocalStateContext } from "../State/LocalState";
import styled from "styled-components";
import BookMark from "../Icons/Bookmark";
import Trophy from "../Icons/Trophy";
import Pages from "../Icons/Pages";
import Book from "../Icons/Book";
import Calendar from "../Icons/Calendar";
import Exclamation from "../Icons/Exclamation";
import { FiEdit2 } from "react-icons/fi";

// Update the StatsContainer component
const StatsContainer = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  grid-template-rows: auto 1fr;
  gap: 20px;
  width: 100%;
  max-width: 400px;
  margin: auto;
  padding: 20px;
  margin-top: 3em;
  border: 0;
  box-shadow: 0 2px 6px 0 rgba(0, 0, 0, 0.2);
  border-top: 6px solid #1a5970;
  transition: all 0.3s ease-in-out;
  
  @media (max-width: 768px) {
    padding: 15px;
    margin-top: 2em;
    max-width: none;
    
    /* Add these properties for when the component is in a modal */
    &.in-modal {
      max-height: 80vh; /* Limit height in modal */
      overflow-y: auto; /* Enable vertical scrolling */
      -webkit-overflow-scrolling: touch; /* Smooth scrolling on iOS */
      scrollbar-width: thin; /* For Firefox */
      scrollbar-color: #1a5970 #f0f0f0; /* For Firefox */
      
      /* Customize scrollbar for WebKit browsers */
      &::-webkit-scrollbar {
        width: 8px;
      }
      
      &::-webkit-scrollbar-track {
        background: #f0f0f0;
        border-radius: 4px;
      }
      
      &::-webkit-scrollbar-thumb {
        background-color: #1a5970;
        border-radius: 4px;
      }
    }
  }
`;

const StatsItemsContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 15px;
`;

const StatsItem = styled.div`
  display: grid;
  grid-template-columns: 40px 1fr;
  grid-template-rows: auto;
  gap: 15px;
  line-height: 1.2;
  transition: all 0.3s ease-in-out;
  
  @media (max-width: 768px) {
    grid-template-columns: 35px 1fr;
    gap: 10px;
  }
  
  h5 {
    margin: 0 0 5px 0;
    font-size: 16px;
    font-weight: 600;
    color: #1a5970; /* Brand color for headings */
    letter-spacing: 0.015em; /* Slightly improved readability */
    
    @media (max-width: 768px) {
      font-size: 14px;
    }
  }
  
  p {
    margin: 0;
    font-size: 15px;
    color: #4a4a4a; /* Slightly lighter than black for body text */
    font-weight: 400; /* Normal weight for body text */
    
    /* Style for emphasized text using the font-semibold class */
    &.font-semibold {
      font-weight: 600;
      color: #333; /* Darker than regular text */
    }
    
    @media (max-width: 768px) {
      font-size: 13px;
    }
  }
`;

const ItemIcon = styled.div`
  height: 40px;
  width: 40px;
  border-radius: 50%;
  border: none;
  display: flex;
  justify-content: center;
  align-items: center;
  transition: all 0.3s ease-in-out;
  
  @media (max-width: 768px) {
  transition: all 0.3s ease-in-out;
    height: 35px;
    width: 35px;
  }
  
  ${({ color }) => {
    switch (color) {
      case "one":
        return "fill: #fff; background: #1a7065;";
      case "two":
        return "fill: #fff; background: #1a6a70;";
      case "three":
        return "fill: #fff; background: #1a5970;";
      case "four":
        return "fill: #fff; background: #1a4870;";
      case "five":
        return "fill: #fff; background: #1a3770;";
      case "warning":
        return "fill: #fff; background: #ffc107;";
      default:
        return "fill: #fff; background: #1a4870;";
    }
  }};
  
  svg {
    width: 20px;
    height: 20px;
    transition: all 0.3s ease-in-out;
    
    @media (max-width: 768px) {
    transition: all 0.3s ease-in-out;
      width: 18px;
      height: 18px;
    }
  }
`;

const ChallengeContainer = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 10px;
  width: 100%;
`;
const ChallengeBox = styled.div`
  border: 2px solid #ffc107;
  border-radius: 8px;
  padding: 15px;
  width: 100%;
  display: grid;
  grid-template-columns: 40px 1fr;
  gap: 15px;
  background-color: rgba(255, 193, 7, 0.05);
  transition: all 0.3s ease-in-out;
  
  @media (max-width: 768px) {
  transition: all 0.3s ease-in-out;
    grid-template-columns: 35px 1fr;
    padding: 12px;
  }
`;

const ChallengeIconContainer = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: center;
`;

const ChallengeTextContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

const ChallengeTextTitle = styled.div`
  font-size: 16px;
  font-weight: 600;
  color: #1a5970;
  letter-spacing: 0.015em;
  margin-bottom: 2px; /* Add a bit more space below title */
  
  @media (max-width: 768px) {
    font-size: 14px;
  }
`;
const ChallengeTextBody = styled.div`
  color: #4a4a4a;
  font-size: 15px;
  line-height: 1.3;
  transition: all 0.3s ease-in-out;
  
  @media (max-width: 768px) {
  transition: all 0.3s ease-in-out;
    font-size: 13px;
  }
`;

const EditGoalButton = styled.button`
  background: none;
  border: none;
  color: #1a5970;
  cursor: pointer;
  padding: 4px;
  margin-left: 8px;
  display: inline-flex;
  align-items: center;
  border-radius: 4px;
  transition: all 0.2s ease;
  
  &:hover {
    background-color: rgba(26, 89, 112, 0.1);
    color: #124354;
  }
`;

const GoalModal = styled.div`
  background-color: rgba(0, 0, 0, 0.5);
  position: fixed;
  z-index: 1000;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
`;

const GoalModalContent = styled.div`
  background-color: #fff;
  border-radius: 8px;
  padding: 2rem;
  max-width: 400px;
  width: 90%;
  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.2);
`;

const GoalModalTitle = styled.h3`
  font-size: 1.5rem;
  color: #1a5970;
  margin: 0 0 1.5rem 0;
  text-align: center;
`;

const GoalInputContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 1.5rem;
  font-size: 1.1rem;
  color: #4a4a4a;
`;

const GoalInput = styled.input`
  width: 80px;
  padding: 0.5rem;
  margin: 0 0.5rem;
  border: 2px solid ${props => props.$error ? '#dc3545' : '#dee2e6'};
  border-radius: 4px;
  font-size: 1.1rem;
  text-align: center;
  
  &:focus {
    outline: none;
    border-color: #1a5970;
  }
`;

const GoalModalActions = styled.div`
  display: flex;
  justify-content: center;
  gap: 1rem;
`;

const ModalButton = styled.button`
  padding: 0.75rem 1.5rem;
  border-radius: 4px;
  font-size: 1rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
  
  ${props => props.$primary ? `
    background-color: #1a5970;
    color: white;
    border: none;
    
    &:hover {
      background-color: #124354;
    }
  ` : `
    background-color: white;
    color: #1a5970;
    border: 1px solid #1a5970;
    
    &:hover {
      background-color: #f5f5f5;
    }
  `}
`;

const ErrorText = styled.div`
  color: #dc3545;
  font-size: 0.875rem;
  text-align: center;
  margin-bottom: 1rem;
`;

export const StatsColumn = ({inModal = false}) => {
  const currentYear = moment().year();
  const daysToNewYear =
    Number(moment().diff(`${currentYear + 1}-01-01`, "days")) * -1;

  const { totalPages, booksRead, bookList, bookGoal, addReadingGoal, user } =
    useContext(LocalStateContext);

  // State for edit goal modal
  const [showEditModal, setShowEditModal] = useState(false);
  const [newGoal, setNewGoal] = useState(bookGoal || "");
  const [inputError, setInputError] = useState(null);
  const [isUpdating, setIsUpdating] = useState(false);

  // Handle goal update
  const handleUpdateGoal = async () => {
    const goalNumber = Number(newGoal);
    
    if (!newGoal || isNaN(goalNumber) || goalNumber <= 0) {
      setInputError("Please enter a valid number greater than 0");
      return;
    }
    
    if (!Number.isInteger(goalNumber)) {
      setInputError("Please enter a whole number");
      return;
    }
    
    setIsUpdating(true);
    setInputError(null);
    
    try {
      const userId = user ? (typeof user === 'object' ? user.id : user) : null;
      await addReadingGoal({ goal: goalNumber, userId });
      setShowEditModal(false);
    } catch (error) {
      setInputError("Failed to update goal. Please try again.");
      console.error("Error updating goal:", error);
    } finally {
      setIsUpdating(false);
    }
  };

  // Open modal and reset state
  const openEditModal = () => {
    setNewGoal(bookGoal || "");
    setInputError(null);
    setShowEditModal(true);
  };

  let extraReading;
  if (bookList[bookGoal]) {
    daysToNewYear > 0
      ? (extraReading = (bookList[bookGoal].book.pages / daysToNewYear).toFixed(
          0
        ))
      : (extraReading = bookList[bookGoal].book.pages.toFixed(0));
  }

  return (
    <div>
    {/* Edit Goal Modal */}
    {showEditModal && (
      <GoalModal onClick={() => setShowEditModal(false)}>
        <GoalModalContent onClick={(e) => e.stopPropagation()}>
          <GoalModalTitle>Update Reading Goal for {currentYear}</GoalModalTitle>
          {inputError && <ErrorText>{inputError}</ErrorText>}
          <GoalInputContainer>
            I want to read
            <GoalInput
              type="number"
              min="1"
              value={newGoal}
              onChange={(e) => {
                setInputError(null);
                setNewGoal(e.target.value);
              }}
              onKeyPress={(e) => {
                if (e.key === 'Enter') handleUpdateGoal();
              }}
              $error={!!inputError}
              autoFocus
            />
            books.
          </GoalInputContainer>
          <GoalModalActions>
            <ModalButton onClick={() => setShowEditModal(false)} disabled={isUpdating}>
              Cancel
            </ModalButton>
            <ModalButton $primary onClick={handleUpdateGoal} disabled={isUpdating}>
              {isUpdating ? 'Updating...' : 'Update Goal'}
            </ModalButton>
          </GoalModalActions>
        </GoalModalContent>
      </GoalModal>
    )}

    <StatsContainer>
      <StatsItemsContainer className={inModal ? 'in-modal' : ''}>
        <StatsItem>
          <ItemIcon color="one">
            <Trophy />
          </ItemIcon>
          <div>
            <h5>
              Reading Goal For {currentYear}:
              <EditGoalButton onClick={openEditModal} title="Edit Goal">
                <FiEdit2 size={14} />
              </EditGoalButton>
            </h5>
            <p className="font-semibold">
              {bookGoal} {bookGoal !== 1 ? "books" : "book"}.
            </p>
          </div>
        </StatsItem>
          <StatsItem>
            <ItemIcon color="two">
              <Book />
            </ItemIcon>
            <div>
              <h5>Books Read This Year:</h5>
              {booksRead !== 1 ? (
                <p className="font-semibold">{booksRead} books.</p>
              ) : (
                <p className="font-semibold">{booksRead} book.</p>
              )}
            </div>
          </StatsItem>
          <StatsItem>
            <ItemIcon color="three">
              <Pages />
            </ItemIcon>
            <div>
              <h5>Pages Left To Read:</h5>
              <p className="font-semibold">
                {bookGoal <= bookList.length
                  ? totalPages > 0
                    ? `${totalPages} pages.`
                    : `${totalPages} page.`
                  : `Add more books to calculate.`}
              </p>
            </div>
          </StatsItem>
          <StatsItem>
            <ItemIcon color="four">
              <Calendar />
            </ItemIcon>
            <div>
              <h5>Days Left In Year:</h5>
              {daysToNewYear > 0 ? (
                <p className="font-semibold">{daysToNewYear} days.</p>
              ) : (
                <p className="font-semibold">{daysToNewYear} day.</p>
              )}
            </div>
          </StatsItem>
          <StatsItem>
            <ItemIcon color="five">
              <BookMark />
            </ItemIcon>
            <div>
              <h5>Pages Per Day to Reach Goal:</h5>
              <p className="font-semibold">
                {bookGoal <= bookList.length
                  ? `${Math.round(totalPages / daysToNewYear)} pages per day.`
                  : `Add more books to calculate.`}
              </p>
            </div>
          </StatsItem>
        </StatsItemsContainer>
        {bookGoal <= bookList.length && (
          <ChallengeContainer>
            <ChallengeBox>
              <ChallengeIconContainer>
                <ItemIcon color="warning">
                  <Exclamation />
                </ItemIcon>
                <div></div>
              </ChallengeIconContainer>
              <ChallengeTextContainer>
                <ChallengeTextTitle>
                  <div>Like to challenge yourself?</div>
                </ChallengeTextTitle>
                <ChallengeTextBody>
                  Read {extraReading} more pages a day, and you will finish 1
                  extra book this year.
                </ChallengeTextBody>
              </ChallengeTextContainer>
            </ChallengeBox>
          </ChallengeContainer>
        )}
      </StatsContainer>
    </div>
  );
};
